import { SectionHubPage } from "../../components/SectionHubPage/SectionHubPage";
import { movementPartiesHubCards } from "../../navigation/appNavigation";
import { SectionLabels } from "../../utils/navigation/pageTitles";

const MovementPartiesHubPage = () => (
    <SectionHubPage title={SectionLabels.movementParties} cards={movementPartiesHubCards} />
);

export { MovementPartiesHubPage };
